<template>
  <nav
    class="header"
    :class="{ 'header-home': isHomePage }"
  >
    <div class="container-fluid--header">
      <div class="header__lines">
        <FirstLine
          :current-view="currentView"
        />
        <StepperChecklist
          v-if="isAppointmentPage"
          class="header__stepper"
        />
      </div>
    </div>
    <ModalInfo
      v-if="showModal"
      @close-modal="showModal = false"
      @agreed="showModal = false"
    />
  </nav>
</template>

<script>
import FirstLine from '@/components/headerComponents/FirstLine.vue';
import StepperChecklist from '@/components/headerComponents/StepperChecklist.vue';
import ModalInfo from '@/components/common/ModalInfo.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Header',
  components: {
    FirstLine,
    StepperChecklist,
    ModalInfo,
  },

  props: {
    currentView: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      showModal: false,
    };
  },

  computed: {
    ...mapGetters([
      'userIsLogged',
      'userGender'
    ]),
    isHomePage() {
      return  this.currentView === 'Home';
    },
    isAppointmentPage() {
      return this.currentView === 'ServiceAppointment';
    }
  },
};
</script>

<style lang="scss" scoped>
  .header {
    width: 100%;
    z-index: -2;
    background-color: $white;

    &-home {
      background-color: $white !important;
    }

    @include screen (tablet-big-up) {
      &__stepper {
        width: 100%;
        border-top: 0.1rem solid $gray-disabled-button;
      }
    }

    @include screen(phone-only) {
      &__lines {
        padding: 0 4%;
      }
    }

    @media print {
      display: none;
    }
  }
</style>
